import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Legacy admin token (single-password admin) — still supported for backwards compat.
export const TOKEN_KEY = "nearme_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY) || "";
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

// New JWT user session token (email/pw or Google auth)
export const USER_TOKEN_KEY = "nearme_user_token";
export const USER_KEY = "nearme_user";
export const getUserToken = () => localStorage.getItem(USER_TOKEN_KEY) || "";
export const setUserToken = (t) => localStorage.setItem(USER_TOKEN_KEY, t);
export const clearUserToken = () => localStorage.removeItem(USER_TOKEN_KEY);
export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "null");
  } catch {
    return null;
  }
};
export const setStoredUser = (u) => localStorage.setItem(USER_KEY, JSON.stringify(u));
export const clearStoredUser = () => localStorage.removeItem(USER_KEY);

export const isAuthenticated = () => !!getToken() || !!getUserToken();

export const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((cfg) => {
  const userTok = getUserToken();
  if (userTok) {
    cfg.headers["Authorization"] = `Bearer ${userTok}`;
  }
  const legacy = getToken();
  if (legacy) {
    cfg.headers["X-Admin-Token"] = legacy;
  }
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      // Never bounce from public/auth pages — those pages own their own error handling.
      const publicPage =
        path === "/login" ||
        path === "/admin/login" ||
        path === "/register" ||
        path.startsWith("/auth/");
      if (!publicPage) {
        clearToken();
        clearUserToken();
        clearStoredUser();
        // Bounce admins back to the ADMIN login, users to /login.
        const dest = path.startsWith("/admin") ? "/admin/login" : "/login";
        window.location.href = dest;
      }
    }
    return Promise.reject(err);
  }
);
